const StaffIndex = () => import('@/pages/lab/staff/StaffIndex');
const StaffDetail = () => import('@/pages/lab/staff/StaffDetail');
const StaffAdd = () => import('@/pages/lab/staff/StaffAdd');
const StaffEdit = () => import('@/pages/lab/staff/StaffEdit');

export class StaffRoutes {

  constructor() {
    this.route_root = 'staff';
    this.type_single = 'Staff';
    this.type_plural = 'Staff';

    this.routes = [
      {
        path: this.route_root,
        name: `List ${this.type_plural}`,
        component: StaffIndex,
        meta: { requiresAuth: true }
      },
      {
        path: `${this.route_root}/add`,
        name: `Add ${this.type_single}`,
        component: StaffAdd,
        meta: {requiresAuth: true}
      },
      {
        path: `${this.route_root}/:staff_id`,
        name: `View ${this.type_single}`,
        component: StaffDetail,
        meta: {requiresAuth: true}
      },
      {
        path: `${this.route_root}/:staff_id/edit`,
        name: `Update ${this.type_single}`,
        component: StaffEdit,
        meta: {requiresAuth: true}
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

